class StickyProductCta extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;

    this.#initObserver();
    this.#initClickHandler(signal);
    this.#initVariantListener(signal);
    this.#initCartListener(signal);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }

  #initObserver() {
    const buyBlock = document.querySelector('.buy-buttons-block');
    if (!buyBlock) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('sticky-cta--visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    this.observer.observe(buyBlock);
  }

  #initClickHandler(signal) {
    const btn = this.querySelector('.sticky-cta__btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const form = document.querySelector('product-form-component');
      if (!form) return;
      const submitBtn = form.querySelector('[ref="addToCartButton"]');
      if (submitBtn && !submitBtn.disabled) submitBtn.click();
    }, { signal });
  }

  #initVariantListener(signal) {
    document.addEventListener('variant:update', (e) => {
      const { resource, data } = e.detail;

      // Update price from server-rendered HTML
      if (data?.html) {
        const newPrice = data.html.querySelector('product-price [ref="priceContainer"]');
        if (newPrice) {
          const priceEl = this.querySelector('.sticky-cta__price');
          if (priceEl) priceEl.textContent = newPrice.textContent.trim();
        }
      }

      if (!resource) return;

      // Update variant title
      const variantEl = this.querySelector('.sticky-cta__variant');
      if (variantEl) {
        const title = resource.title;
        variantEl.textContent = (title && title !== 'Default Title') ? title : '';
      }

      // Update thumbnail if variant has specific media
      if (resource.featured_media?.preview_image?.src) {
        const thumb = this.querySelector('.sticky-cta__thumb');
        if (thumb) {
          const src = resource.featured_media.preview_image.src;
          thumb.src = src + (src.includes('?') ? '&' : '?') + 'width=96';
        }
      }

      // Update button availability
      const btn = this.querySelector('.sticky-cta__btn');
      if (btn) {
        btn.disabled = !resource.available;
      }
    }, { signal });
  }

  #initCartListener(signal) {
    document.addEventListener('cart:update', (e) => {
      if (e.detail?.data?.source !== 'product-form-component') return;
      if (e.detail?.data?.didError) return;

      const btn = this.querySelector('.sticky-cta__btn');
      if (!btn || btn.disabled) return;

      const addText = this.dataset.addText || '';
      const addedText = typeof Theme !== 'undefined' ? Theme.translations?.added : '✓';

      btn.textContent = addedText || '✓';
      btn.classList.add('sticky-cta__btn--added');

      clearTimeout(this._feedbackTimer);
      this._feedbackTimer = setTimeout(() => {
        btn.textContent = addText;
        btn.classList.remove('sticky-cta__btn--added');
      }, 2000);
    }, { signal });
  }
}

if (!customElements.get('sticky-product-cta')) {
  customElements.define('sticky-product-cta', StickyProductCta);
}
